import { makeAutoObservable, runInAction } from "mobx";

export default class roleStore {
  role = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.role = [];
    runInAction(() => {
      this.role = data;
    });
  };

  deleteRole = (id) => {
    let objIndex = this.role.findIndex((role => role.id == id));
    if(objIndex !== -1) {
      this.role[objIndex].isActive = false;
    }
  };
}
